import { StorageRootDto } from '..';
import { ValueEncoder } from 'DiscoveryEngine.TS/Utils';


export class ServerDto extends StorageRootDto {

    public Name: string;
    public AwolSubServers_Enabled: boolean;
	public AwolSubServers_Days: number;
	public AwolSubServers_Hours: number;
	public AwolSubServers_Minutes: number;
   
    constructor() {
        super();

        this.Name = "";
        this.AwolSubServers_Enabled = false;
		this.AwolSubServers_Days = 0;
		this.AwolSubServers_Hours = 0;
		this.AwolSubServers_Minutes = 0;
    }

    public get HasName(): boolean {
        return !!this.Name;
    }
    
	public Write(obj: any, context: any): void {
		obj.server = {};
		obj = obj.server;

		super.Write(obj, context);

		if (this.HasName) {
			obj.name = this.Name;
		}

		obj.awol_sub_servers_enabled = ValueEncoder.EncodeBoolean(this.AwolSubServers_Enabled);
		obj.awol_sub_servers_days = ValueEncoder.EncodeInteger(this.AwolSubServers_Days);
		obj.awol_sub_servers_hours = ValueEncoder.EncodeInteger(this.AwolSubServers_Hours);
		obj.awol_sub_servers_minutes = ValueEncoder.EncodeInteger(this.AwolSubServers_Minutes);
	}

	public Read(obj: any, context: any): void {
		if (!obj.server)
			throw new Error();
		obj = obj.server;

		super.Read(obj, context);

		if (obj.name !== undefined) {
			this.Name = obj.name;
		}
		if (obj.awol_sub_servers_enabled !== undefined) {
			this.AwolSubServers_Enabled = ValueEncoder.DecodeBoolean(obj.awol_sub_servers_enabled);
		}
		if (obj.awol_sub_servers_days !== undefined) {
			this.AwolSubServers_Days = ValueEncoder.DecodeInteger(obj.awol_sub_servers_days);
		}
		if (obj.awol_sub_servers_hours !== undefined) {
			this.AwolSubServers_Hours = ValueEncoder.DecodeInteger(obj.awol_sub_servers_hours);
		}
		if (obj.awol_sub_servers_minutes !== undefined) {
			this.AwolSubServers_Minutes = ValueEncoder.DecodeInteger(obj.awol_sub_servers_minutes);
		}
	}
}
